module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAPUExURUdwTCJq/yJo/yJo/yJq//1fb0UAAAAEdFJOUwBgUOd/kYc1AAAAOklEQVQY02NgoDFgUkDiiDgi2IwuJgJIEiqOCAkBIELSAdMFFoVJQQQhJFQMQjFDVYsYINmO4gpqAABTPAXZvUx60AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/up.png
// module id = M9VV
// module chunks = 34